export default "__VITE_ASSET__Cnz5a7DR__$_?url__"